module.exports = __webpack_public_path__ + "static/img/brett-jordan-tHTN5m7IsPw-unsplash_thumb.176f2c5.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ads/standard_bg/brett-jordan-tHTN5m7IsPw-unsplash_thumb.png
// module id = Uj68
// module chunks = 4